import React from "react";
import { Container, Typography, Box, Link, Paper } from "@mui/material";

const Impressum = () => {
  return (
    <Container  maxWidth="md" sx={{ mt: 4 ,marginTop: "15vh"}}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom>
          Impressum
        </Typography>
        <Typography variant="body1" gutterBottom>
          Angaben gemäß § 5 TMG
        </Typography>
        
        <Box sx={{ my: 2 }}>
          
          <Typography variant="h6">Elektrokonzept</Typography>
          <Typography>Hasan Zakour</Typography>

          <Typography>          65594 Runkel-Steeden
</Typography>
          <Typography> Schulstraße 48 </Typography>

        </Box>
       

        <Box sx={{ my: 2 }}>
          <Typography variant="h6">Kontakt:</Typography>
          <Typography>Mobil: +49 1590 1600845</Typography>
          <Link href="https://elektrokonzept-limburg.de/" target="_blank" rel="noopener noreferrer">
          www.elektrokonzept-limburg.de
          </Link>
          <br/>
          <Link href="info@elektrokonzept-limburg.de" target="_blank" rel="noopener noreferrer">
          Email: info@elektrokonzept-limburg.de          </Link>
        
        </Box>

     
        
        <Box sx={{ my: 2 }}>
          <Typography>Steuernummer: 03088501136</Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6">Alle Rechte vorbehalten.</Typography>
          <Typography>
            Die Inhalte, das Layout und Design dieser Website sind urheberrechtlich geschützt.
            Eine Nutzung des Layouts und aller Inhalte sind nur auf Anfrage und mit ausdrücklicher Genehmigung gestattet.
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h6">Haftungsausschluss:</Typography>
          <Typography>
            Für die Inhalte externer Links übernehmen ElektrotechnikEMN, trotz sorgfältiger inhaltlicher Kontrolle, keine Haftung.
            Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default Impressum;
